export function isDemo(demoValue, defaultValue) {
    const isDemoEnv = window.location.hostname === "portal-demo.arcspan.com" || window.location.hostname === "localhost";
    return isDemoEnv ? demoValue : defaultValue;
}